import { 
  apiService, 
  MonitoredIdentityDto, 
  CreateMonitoredIdentityDto, 
  UpdateMonitoredIdentityDto, 
  UpdateLabelDto,
  MentionDto 
} from './api';

export class MonitoredIdentityService {
  /**
   * Get all monitored identities for the authenticated account
   */
  async getAll(token: string): Promise<MonitoredIdentityDto[]> {
    return apiService.getMonitoredIdentities(token);
  }

  /**
   * Get a specific monitored identity by ID
   */
  async getById(token: string, id: string): Promise<MonitoredIdentityDto> {
    return apiService.getMonitoredIdentity(token, id);
  }

  /**
   * Create a new monitored identity
   */
  async create(token: string, identityData: CreateMonitoredIdentityDto): Promise<MonitoredIdentityDto> {
    return apiService.createMonitoredIdentity(token, identityData);
  }

  /**
   * Update an existing monitored identity
   */
  async update(token: string, id: string, identityData: UpdateMonitoredIdentityDto): Promise<MonitoredIdentityDto> {
    return apiService.updateMonitoredIdentity(token, id, identityData);
  }

  /**
   * Update the label of a monitored identity
   */
  async updateLabel(token: string, id: string, label: string | null): Promise<MonitoredIdentityDto> {
    return apiService.updateMonitoredIdentityLabel(token, id, { label });
  }

  /**
   * Delete a monitored identity
   */
  async delete(token: string, id: string): Promise<void> {
    return apiService.deleteMonitoredIdentity(token, id);
  }

  /**
   * Get all mentions for all monitored identities of the account
   */
  async getAllMentions(token: string, page: number = 1, pageSize: number = 20): Promise<MentionDto[]> {
    return apiService.getAllAccountMentions(token, page, pageSize);
  }

  /**
   * Get mentions for a specific monitored identity
   */
  async getMentions(token: string, id: string, page: number = 1, pageSize: number = 20): Promise<MentionDto[]> {
    return apiService.getMonitoredIdentityMentions(token, id, page, pageSize);
  }
}

export const monitoredIdentityService = new MonitoredIdentityService();